import { observer } from "mobx-react";

import "./ProjectsActiveReportAuctionSliderMark.scss";

export const ProjectsActiveReportAuctionSliderMark = observer(({ store, value }) => {
  const isActive = value === store.markValues[store.value];
  
  return <span className={`mark ${isActive ? " active" : ""}`}>{value} ₽</span>;
});
